import { render, staticRenderFns } from "./MagazzinoArticoliEditComponent.vue?vue&type=template&id=63a606f0"
import script from "./MagazzinoArticoliEditComponent.vue?vue&type=script&lang=js"
export * from "./MagazzinoArticoliEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports